import { Button, Input } from "components";
import React, { useEffect, useState, useRef } from "react";
import { useSelector } from "react-redux";

const AddNewTenant = ({ makeTabActive }) => {
  // Get the user
  const user = useSelector((state) => state.auth.userData);

  // Check if just a building is being created
  const isCreateNewBuilding = localStorage.getItem("createNewBuilding");

  // Array to define the buildings/tenants
  const buildingInfo =
    JSON.parse(localStorage.getItem("buildingInfo")) ||
    JSON.parse(localStorage.getItem("buildingAdminInfo"));
  const { numberOfApartments } = buildingInfo;
  const createArray = (num) => {
    return Array.from({ length: num }, (_, i) => i + 1);
  };
  const buildings = createArray(numberOfApartments);
  const [error, setError] = useState("");

  // State for the inputs
  const [formData, setFormData] = useState(
    buildings.map(() => ({
      tenantName: "",
      tenantPhoneNumber: "",
      tenantEmailAddress: "",
      billingStartDate: "",
    }))
  );

  // Check if email is correct state
  const [isEmailCorrect, setIsEmailCorrect] = useState(false);

  // Regex for the email
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

  const validateEmail = (index, email) => {
    if (!emailRegex.test(email)) {
      setError(`Invalid email address for Tenant ${index + 1}: ${email}`);
      setIsEmailCorrect(false);
    } else {
      setError(``);
      setIsEmailCorrect(true);
    }
  };

  const clearEmailValidation = () => {
    setError(``);
  };

  const [errors, setErrors] = useState([]);

  useEffect(() => {
    if (user?.role === "ROLE_SUPER_ADMIN") {
      const savedData = JSON.parse(localStorage.getItem("tenantData"));
      if (savedData) {
        setFormData(savedData);
      }
    } else if (user?.role === "ROLE_ADMIN") {
      const savedData = JSON.parse(localStorage.getItem("adminTenantData"));
      if (savedData) {
        setFormData(savedData);
      }
    }
  }, []);

  // Check if all inputs are empty
  const areAllInputsEmpty = () => {
    return formData.every(
      (tenant) =>
        !tenant.tenantName.trim() &&
        !tenant.tenantPhoneNumber.trim() &&
        !tenant.tenantEmailAddress.trim() &&
        !tenant.billingStartDate
    );
  };

  // Validate inputs
  const validateInputs = () => {
    const newErrors = [];

    formData.forEach((tenant, index) => {
      const {
        tenantName,
        tenantPhoneNumber,
        tenantEmailAddress,
        billingStartDate,
      } = tenant;

      const tenantErrors = {};

      // Check if any of the required fields are filled
      const isAnyRequiredFieldFilled =
        tenantName.trim() || tenantEmailAddress.trim() || billingStartDate;

      if (isAnyRequiredFieldFilled) {
        // If any required field is filled, enforce all required fields
        if (!tenantName.trim()) {
          tenantErrors.tenantName = "Name is required.";
        }
        if (!tenantEmailAddress.trim()) {
          tenantErrors.tenantEmailAddress = "Email address is required.";
        }
        if (!billingStartDate) {
          tenantErrors.billingStartDate = "Billing Date is required.";
        }
      }

      newErrors[index] = tenantErrors;
    });

    setErrors(newErrors);

    // Check if there are any errors
    const hasErrors = newErrors.some(
      (tenantError) => Object.keys(tenantError).length > 0
    );

    if (hasErrors) {
      setError(
        "Please fill out all required fields for the tenants you've started."
      );
    }

    return !hasErrors; // Return true if there are no errors
  };

  const handleInputChange = (index, field, value) => {
    const updatedFormData = [...formData];

    // Checks for duplicate email
    if (field === "tenantEmailAddress") {
      const isDuplicate = formData.some(
        (item, idx) => item.tenantEmailAddress === value && idx !== index
      );

      if (isDuplicate) {
        setError(
          `Email Address "${value}" is already in use. Please enter a unique email Address.`
        );
        return; // Prevent further updates for duplicate values
      }
    }

    updatedFormData[index][field] = value;
    setFormData(updatedFormData);

    // Clear error for the specific field if the input is no longer empty
    const updatedErrors = [...errors];
    if (updatedErrors[index] && value.trim() !== "") {
      delete updatedErrors[index][field];
    }
    setErrors(updatedErrors);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Check if all inputs are empty
    if (areAllInputsEmpty()) {
      // if all inputs are empty, then  u can proceed to the next page
      if (isCreateNewBuilding) {
        localStorage.setItem("tenantData", null);
        makeTabActive(5);
        return;
      }
      // if (user?.role === "ROLE_SUPER_ADMIN") {
      localStorage.setItem("tenantData", null);
      makeTabActive(5);
      // } else if (user?.role === "ROLE_ADMIN") {
      //   localStorage.setItem("adminTenantData", null);
      //   makeTabActive(5);
      // }
    } else if (validateInputs()) {
      // checks if all inputs are validated and the email is correct
      if (isCreateNewBuilding) {
        localStorage.setItem("tenantData", JSON.stringify(formData));
        makeTabActive(5);
        return;
      }
      // if (user?.role === "ROLE_SUPER_ADMIN") {
      localStorage.setItem("tenantData", JSON.stringify(formData));
      makeTabActive(6);
      // } else if (user?.role === "ROLE_ADMIN") {
      //   localStorage.setItem("adminTenantData", JSON.stringify(formData));
      //   makeTabActive(5);
      // }
    }
  };

  const goBack = () => {
    if (isCreateNewBuilding) {
      makeTabActive(3);
      return;
    }
    if (user?.role === "ROLE_SUPER_ADMIN") {
      makeTabActive(4);
    } else if (user?.role === "ROLE_ADMIN") {
      makeTabActive(4);
    }
  };

  return (
    <>
      <form>
        <div className="mt-4">
          <div>
            <h3 className="building-header">Add Tenants</h3>
          </div>
        </div>

        {buildings.map((building, index) => (
          <div key={index}>
            <h4 className="font-bold mt-4 mb-2">Tenant {building}</h4>
            <div className="customer-form-wrapper">
              <Input
                wrapClassName="bg-gray_100 border-[1px] border-light_blue_800 border-solid flex flex-row font-montserrat h-[66px] items-center justify-start px-[20px] py-[11px] rounded-[10px] w-full"
                className="font-semibold text-gray_600 text-[16px] w-full"
                name={`tenantName-${index}`}
                value={formData[index]?.tenantName || ""}
                onChange={(e) =>
                  handleInputChange(index, "tenantName", e.target.value)
                }
                labelText="Tenant Name"
                onClick={clearEmailValidation}
              />

              <Input
                wrapClassName="bg-gray_100 border-[1px] border-light_blue_800 border-solid flex flex-row font-montserrat h-[66px] items-center justify-start px-[20px] py-[11px] rounded-[10px] w-full"
                className="font-semibold text-gray_600 text-[16px] w-full"
                name={`tenantPhoneNumber-${index}`}
                value={formData[index]?.tenantPhoneNumber || ""}
                type="number"
                onChange={(e) =>
                  handleInputChange(index, "tenantPhoneNumber", e.target.value)
                }
                labelText="Tenant Phone Number"
              />

              <Input
                wrapClassName="bg-gray_100 border-[1px] border-light_blue_800 border-solid flex flex-row font-montserrat h-[66px] items-center justify-start px-[20px] py-[11px] rounded-[10px] w-full"
                className="font-semibold text-gray_600 text-[16px] w-full"
                name={`tenantEmailAddress-${index}`}
                type="email"
                value={formData[index]?.tenantEmailAddress || ""}
                onChange={(e) =>
                  handleInputChange(index, "tenantEmailAddress", e.target.value)
                }
                onBlur={(e) => validateEmail(index, e.target.value)}
                labelText="Tenant Email Address"
              />

              <Input
                wrapClassName="bg-gray_100 border-[1px] border-light_blue_800 border-solid flex flex-row font-montserrat h-[66px] items-center justify-start px-[20px] py-[11px] rounded-[10px] w-full"
                className="font-semibold text-gray_600 text-[16px] w-full"
                name={`tenantEmailBillingDate-${index}`}
                type="date"
                value={formData[index]?.billingStartDate || ""}
                labelText="Billing Start Date"
                onChange={(e) =>
                  handleInputChange(index, "billingStartDate", e.target.value)
                }
              />
            </div>
            <div className="mt-2">
              {errors[index]?.tenantName && (
                <p className="text-[red] text-[12px]">
                  {errors[index].tenantName}
                </p>
              )}
              {errors[index]?.tenantEmailAddress && (
                <p className="text-[red] text-[12px]">
                  {errors[index].tenantEmailAddress}
                </p>
              )}
              {errors[index]?.billingStartDate && (
                <p className="text-[red] text-[12px]">
                  {errors[index].billingStartDate}
                </p>
              )}
            </div>
          </div>
        ))}
        <p className="text-[red] mt-2 text-[12px]">{error}</p>
      </form>
      <div className="mt-4">
        <Button
          onClick={goBack}
          className="border-[1px] mr-4 border-light_blue_800 bg-white cursor-pointer font-extrabold h-[64px] px-[7px] rounded-[10px] text-[14px] text-center text-light_blue_800 w-[150px]"
        >
          Back
        </Button>
        <Button
          onClick={handleSubmit}
          className="bg-light_blue_800 cursor-pointer font-extrabold h-[64px] px-[7px] rounded-[10px] text-[14px] text-center text-white w-[150px]"
        >
          Next
        </Button>
      </div>
    </>
  );
};

export default AddNewTenant;
